import Button from 'components/Basic/Button';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'store';
import { setMoveStage, setRotateStage } from 'store/slices/ToolSlice';

export default function RotateButton() {
	const { rotateStage } = useSelector((state: RootState) => state.toolNewPostions.data);
	const dispatch = useDispatch<AppDispatch>();

	return (
		<div className='rotatebtn-wrap'>
			<Button
				id="rotate-btn"
				className='zoombtnHover rotate-btn'
				style={{
					fontSize: '0.938rem',
					borderRadius: '4px',
					fontWeight: '600',
					background: `${rotateStage ? 'var(--secondary)' : 'var(--controlBgColor)'}`,
					border: 'transparent',
					color: 'var(--secondaryTextColor)',
					padding: '0',
					boxShadow: '0px 0.5px 1.5px #0000001a',
					marginBottom: '10px',
					width: '38px',
					height: '38px'
				}}
				tooltipContent='Rotate (Hold Alt)'
				onClick={() => {
					const next = !rotateStage;
					dispatch(setRotateStage({ shouldRotateStage: next }));
					// Move and Rotate are mutually exclusive nav modes on the stage.
					if (next) dispatch(setMoveStage({ shouldMoveStage: false }));
				}}>
				<svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M14.9 9a5.9 5.9 0 0 1-10.3 3.9M3.1 9A5.9 5.9 0 0 1 13.4 5.1"
						stroke={rotateStage ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}
						strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
					<path d="M13.7 2.9v2.6h-2.6M4.3 15.1v-2.6h2.6"
						stroke={rotateStage ? 'var(--darkAccentColor)' : 'var(--defaultIconColor)'}
						strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
				</svg>
			</Button>
		</div>
	);
}
